const defaultMessage =
  "The server encountered an error. Please try again later.";
const defaultTitle = "An error occurred";

const fourOhFourMessage =
  "The requested form could not be found. Please double-check your url and try again!";
const fourOhFourTitle = "Form not found";

export default {
  methods: {
    getErrorMessage(status, code) {
      if (status == 404) {
        return fourOhFourMessage;
      }
      return this.errors[code] ? this.errors[code].message : defaultMessage;
    },
    getErrorTitle(status, code) {
      if (status == 404) {
        return fourOhFourTitle;
      }
      return this.errors[code] ? this.errors[code].title : defaultTitle;
    }
  },
  data() {
    return {
      errors: {
        INVALID_SETUP: {
          err: "INVALID_SETUP",
          title: "Form not set up",
          message:
            "It looks like the requested form is not set up correctly. Please contact the form owner."
        },
        NO_EDITS: {
          err: "NO_EDITS",
          title: "No edits",
          message: "This form is not accepting edits"
        },
        NO_SUBMISSIONS: {
          err: "NO_SUBMISSIONS",
          title: "Form closed",
          message: "This form is not currently accepting any submissions."
        },
        NO_NEW_SUBMISSIONS: {
          err: "NO_NEW_SUBMISSIONS",
          title: "Form closed",
          message: "This form is not currently accepting new submissions."
        },
        ROW_NOT_FOUND: {
          err: "ROW_NOT_FOUND",
          message:
            "The requested form link is not valid. Please try again later, or contact the form owner",
          status: 404
        },
        OVERSIZED_ATTACHMENT: {
          err: "OVERSIZED_ATTACHMENT",
          title: "Oversized attachment",
          message:
            "An attachment is larger than the 4mb limit. Please try again with a smaller attachment."
        },
        EMPTY_REQUEST: {
          err: "EMPTY_REQUEST",
          title: "Empty form",
          message:
            "The server didn't receive any form answers. Please try again with correctly answered questions."
        },
        UNAUTHORIZED: {
          err: "UNAUTHORIZED",
          title: "Unauthorized request",
          message:
            "Hmm. It looks like you don't have permission to complete this request."
        }
      }
    };
  }
};
